export class LoanApplicationTagsAssignmentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanTagAssignmentsHistory({ applicationId, companyId }) {
    return this.#http.get(
      `/api/companies/${companyId}/loanTagAssignments/applications/${applicationId}/history`,
    );
  }
}
